import { CheckCircle2 } from "lucide-react";
import { Reveal } from "./Reveal";
import { useCopy } from "../i18n/copy";

export const TrustSection = () => {
  const c = useCopy("trust");
  return (
    <section className="section-gap bg-paper-tint tech-grid-bg" data-testid="trust-section">
      <div className="container-site">
        <Reveal>
          <p className="tech-label mb-4">{c.kicker}</p>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold max-w-2xl leading-snug">
            {c.title}
          </h2>
        </Reveal>
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
          {c.points.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.05}>
              <div className="flex gap-3.5">
                <CheckCircle2 size={20} className="mt-0.5 shrink-0 text-precision" aria-hidden="true" />
                <div>
                  <h3 className="text-base font-semibold text-ink">{p.title}</h3>
                  <p className="mt-1.5 text-sm text-slate-600 leading-relaxed">{p.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
